import { CountryCode } from "../../domain/i18n/country-code.js";
import { useCoreDispatch, useCoreSelector } from "../../redux/config.js";
import { selectCountry } from "../../redux/i18n/selectors.js";
import { getCountry } from "../../redux/i18n/thunks/get-country.js";
import { useCallback, useEffect } from "react";
//#region src/presentation/hooks/use-country.ts
var phoneNumberFormatters = {
	[CountryCode.GT]: (phoneNumber) => phoneNumber.replace(/(\+\d{3})(\d{4})(\d{4})/, "$1 $2-$3"),
	[CountryCode.DO]: (phoneNumber) => phoneNumber.replace(/(\+\d)(\d{3})(\d{3})(\d{4})/, "$1 $2-$3-$4"),
	[CountryCode.HN]: (phoneNumber) => phoneNumber.replace(/(\+\d{3})(\d{4})(\d{4})/, "$1 $2-$3")
};
var useCountry = () => {
	const dispatch = useCoreDispatch();
	const country = useCoreSelector(selectCountry());
	const countryCode = country?.countryCode;
	const fetchCountry = useCallback(async () => {
		if (!country) await dispatch(getCountry());
	}, [country]);
	useEffect(() => {
		fetchCountry();
	}, [fetchCountry]);
	const formatPhoneNumber = (phoneNumber) => {
		const format = phoneNumberFormatters[countryCode];
		return format ? format(phoneNumber) : phoneNumber;
	};
	return [
		country,
		countryCode,
		formatPhoneNumber
	];
};
//#endregion
export { useCountry };

//# sourceMappingURL=use-country.js.map